<template>
	<div class="display_wrapper">

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Units</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon @click="fn_edit" v-if="displayData && !displayData.isSystem">
		    	<v-icon>edit</v-icon>
		    </v-btn>

		    <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn>
		</v-toolbar>

		<div class="display hasToolbar">
			<div class="display_title">{{displayData.name}}</div>

			<v-list class="section-container" two-line>
		        <v-subheader light>Details</v-subheader>
		        <v-divider></v-divider>
		        <div v-if="false">
		        	<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Short Name</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.shortName ? displayData.shortName : '-'}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		        </div>
		       	<!-- <div>
		       	 	<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Decimal Places</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.decimalPlaces ? displayData.decimalPlaces : '-'}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		       	</div> -->
		       	<div v-if="$root.CurrentBusiness.GSTRegistrationStatus==1">
		       	 	<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Unit Qty Code</v-list-tile-title>
			              	<v-list-tile-sub-title>{{fn_getUnitQuantityName(displayData.unitQuantityCode)}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
		       	</div>
		       <!--  <div v-if="displayData.baseUnitId">
		        	<v-list-tile>
		          		<v-list-tile-content>
		          			<v-list-tile-title>Base Unit</v-list-tile-title>
		              		<v-list-tile-sub-title>{{displayData.baseUnit.name}}</v-list-tile-sub-title>
		            	</v-list-tile-content>
		        	</v-list-tile>
		        	<v-divider></v-divider>
		        </div>
		        <div>
		        	<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Conversion Type</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.conversionType == 101 ? 'Nil' : displayData.conversionType == 102 ? 'Custom' : 'Fixed'}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		        </div>
		       	<div v-if="displayData.conversionType == 103">
		       		<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Conversion Quantity</v-list-tile-title>
			              	<v-list-tile-sub-title>{{displayData.conversionQuantity}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
		       	</div> -->

		    </v-list>
		</div>

		<dialog-confirmation ref="ref_dialogDeleteConfirmation" header="Delete Master?" :actionMethod="fn_deleteMaster" params="delete" :displayView='true'></dialog-confirmation>

	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
const unitQuantityCodes = require('../../../../config.js').configs.unitQuantityCodes;
import {masterMixin} from '../../master_mixin.js'
import dialogConfirmation from '../../../dialogs/dialog_confirmation'

	export default{
		mixins: [masterMixin],
		data(){
			return{
				displayData:{}
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation
		},
		methods:{
			fn_getUnitQuantityName: function(code){
				for(let i=0; i<unitQuantityCodes.length; i++){
					if(unitQuantityCodes[i].id == code){
						return unitQuantityCodes[i].name;
					}
				}
			},

			fn_get: function(itemId){
				var self = this;
				this.getData('Units', itemId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          self.displayData = JSON.parse(response);
				          self.displayData.shortName == 'null' ? self.displayData.shortName = null : '';
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},
			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Units";
				viewObject.TopMenu = [menuItem.edit];
				viewObject.isBottomMenu = true;

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';

				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_getBottomMenu: function (tagId) {
				var bottomMenu = {"BottomMenu": [menuItem.copy]};
				!this.displayData.isSystem ? bottomMenu.BottomMenu.push(menuItem.delete) : '';

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit' && this.displayData && this.displayData.unitId){
					this.fn_edit();
				}
				else if(menuAction=='copy'){
					this.$router.push({path:'/inventory/units/new', query:{tagId:this.guidWeb(), itemId:this.displayData.unitId, copy:true}});
				}
				else if(menuAction=='delete'){
					this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = true;
				}
			},

			fn_deleteMaster: function(){
				let self = this;
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				this.fn_deleteMasterItem('units', this.displayData.unitId, function(response){
					if(response){
                        self.showToast('Item deleted');
                        self.$router.go(-1);
                    }
                    else{
                        self.showToast("Item cannot be deleted as already in use");
                    }
				})
			},

			fn_edit: function () {
				this.$router.push("/inventory/units/"+this.displayData.unitId+"/edit");
			}
		},
		mounted: function(){
			
			this.fn_showWebView();

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			
			if(this.$route.params && this.$route.params.tagId){
				this.fn_get(this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation){
				this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
				next(false);
			}
			else{
				next(true);
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/units/display.vue